<style lang="scss" scoped>
.detail-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .item {
    width: 45%;
  }
}
.detais {
  li {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 12px;
    color: #666;
    .label {
      width: 75px;
      text-align: right;
    }
    .content {
      flex: 1;
    }
  }
}
</style>
<template>
  <div>
    <div class="detail-box">
      <div class="item">
        <el-card class="box-card">
          <div
            slot="header"
            class="clearfix"
          >
            <span>变更前</span>
          </div>
          <ItemDetails
            :data="configPrev"
            :changes="change_items"
          />
        </el-card>
      </div>
      <div class="item">
        <el-card class="box-card">
          <div
            slot="header"
            class="clearfix"
          >
            <span>变更后</span>
          </div>

          <ItemDetails
            :data="config"
            :changes="change_items"
          />
          <ul />
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import ItemDetails from './itemdetails'

export default {
  components: {
    ItemDetails
  },
  props: {
    data: Array
  },
  data () {
    return {
      key: 1,
      detail: {},
      config: {}, //变更前
      configPrev: {}, //变更后
      change_items: []
    }
  },
  computed: {
    id () {
      return this.data[0].id
    }
    // title() {
    //   return  this.title
    // }
  },
  watch: {},
  mounted () {
    const data = this.data[0]
    this.config = data.config
    this.configPrev = data.config_prev
    this.change_items = data.change_items
    this.config.is_active = data.is_active
    this.configPrev.is_active = data.is_active
    this.configPrev.type = 'prev'
    this.config.type = 'next'
  },
  methods: {
    initHtml (data) {
      return ` <li>
              <span class="label">总额度：</span>
              <span class="content">${data.total_money}元</span>
            </li>
            <li>
              <span class="label">红包类型：</span>
              <span class="content">${data.money_type === 'random' ? '随机金额' : '固定金额'}
              </span>
            </li>
            <li v-if="${data.money_type === 'random'}">
              <span class="label">红包额度：</span>
              <span class="content">${data.min_money} ~ ${data.max_money}</span>
            </li>
            <li v-else-if="${data.money_type === 'fixed'}">
              <span class="label">红包额度：</span>
              <span class="content">${data.min_money}</span>
            </li>
            <li>
              <span class="label">活动时间段：</span>
              <span class="content">${data.begin_time}至${data.end_time}</span>
            </li>
            <li>
              <span class="label">发放类型：</span>
              <span class="content">
                <span v-if="${data.send_type === 'at_once'}">立即发放</span>
                <span v-if="${data.send_type === 'delay'}">延时发放</span>
                <span v-if="${data.send_type === 'timing'}">定时发放</span>
              </span>
            </li>
            <li>
              <span class="label">是否开启：</span>
              <span class="content">开</span>
            </li>`
    }
  }
}
</script>
